import {
  Title,
  Text,
  Container,
  Image,
  Box,
  Grid,
  GridCol,
  Badge,
  List,
  rem,
  ListItem,
} from "@mantine/core";
import classes from "./FeatureSection.module.css";
import { IconCircleCheck } from "@tabler/icons-react";

export function FeatureChecklistItem({ text }) {
  return <ListItem align="top">{text}</ListItem>;
}

export function FeatureChecklist({ children }) {
  return (
    <List
      spacing="xs"
      icon={<IconCircleCheck style={{ width: rem(16), height: rem(16) }} />}
    >
      {children}
    </List>
  );
}

function FeatureSection({ tagline, title, text, imageSrc, children, flip }) {
  return (
    <Box className={classes.section} ta="left">
      <Container size="md">
        <Grid gap={{ base: "sm", sm: "xl" }}>
          <GridCol
            order={{ base: 2, sm: flip ? 1 : 2 }}
            span={{ base: 12, sm: 7 }}
          >
            <Badge variant="filled" radius="sm" size="lg">
              {tagline}
            </Badge>
            <Title ta="left" my="md" order={3}>
              {title}
            </Title>
            <Text mb="md">{text}</Text>
            {children}
          </GridCol>
          <GridCol
            order={{ base: 1, sm: flip ? 2 : 1 }}
            style={{ alignContent: "center", justifyItems: "center" }}
            span={{ base: 12, sm: 5 }}
          >
            <Image
              alt=""
              radius="sm"
              sizes="100vw"
              style={{ width: "100%", height: "auto" }}
              fit="contain"
              component={NextImage}
              src={imageSrc ?? "https://placehold.co/600x400.png"}
              width={600}
              height={400}
            />
          </GridCol>
        </Grid>
      </Container>
    </Box>
  );
}

export default FeatureSection;
